import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

// Fetches an Entity's fieldDefs once and exposes lookups for its ENUM / ENTITY_ENUM fields (code or id -> EnumSpec / displayName), for
// read-only rendering outside of a form (e.g. lists/cards that otherwise show raw enum codes).
export const useEnumDisplayNames = (module, entity) => {
  const rsrc = useRsrc();
  const [fieldDefs, setFieldDefs] = useState(null);

  useEffect(() => {
    rsrc.fieldDefs(module, entity).then(setFieldDefs);
  }, [module, entity]);

  // EnumSpec: { id, code, displayName, icon, color } - same shape Grid/EnumCellRenderer use
  const getEnumSpec = (field, value) => {
    if (value == null) return null;
    const fieldDef = fieldDefs?.find((candidate) => candidate.field === field);
    // ENTITY_ENUM stores the FK id; plain enums store the code
    const key = fieldDef?.type === 'ENTITY_ENUM' ? 'id' : 'code';
    return fieldDef?.values?.find((spec) => spec[key] === value) ?? null;
  };

  const displayName = (field, value) => {
    if (value == null) return null;
    return getEnumSpec(field, value)?.displayName ?? value;
  };

  return { displayName, getEnumSpec };
};
